export default "__VITE_ASSET__Puq8X3MS__"